<template>
  <div class="content-order-data" :class="resizeClass">
    <h2>Dados do pedido</h2>
    <h3>{{ data.seller }}</h3>
    <p>{{ data.dateCreated | moment-complete }}</p>
    <h3>Pedido #{{ data.reference }}</h3>

    <div v-for="i in data.cart" v-bind:key="i.id">
       <div class="order" v-if="i.quantity && i.description && i.amount">
        <div class="order-text">{{ i.quantity }}x {{ i.description }}</div>
        <div class="order-value">{{ i.amount | numeral('$ 0,0.00') }}</div>
      </div>
    </div>
    <hr />
    <div class="order abstract" v-if="data.shipping">
      <div class="order-text shipping">Frete</div>
      <div class="order-value shipping">{{ data.shipping | numeral('$ 0,0.00') }}</div>
    </div>
    <div class="order abstract" v-if="data.payment.amount">
      <div class="order-text amount">Valor total</div>
      <div class="order-value amount"><strong>{{ data.payment.amount | numeral('$ 0,0.00') }}</strong></div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      data: []
    }
  },
  props: ['resizeClass'],
  mounted () {
    this.getCustomerOrderData()
  },
  methods: {
    getCustomerOrderData () {
      this.$http.get('api/order-validation/' + this.$route.params.txid + '/customer-order-data')
        .then(function (res) {
          this.data = res.data
          this.$emit('emit-seller', this.data.seller)
          this.$emit('emit-reference', this.data.reference)
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.content-order-data {
  padding: 0 32px;
  float: left;
  h2 {
    margin-top: 24px;
  }
  h3 {
    margin-top: 24px;
    font-size: 14px;
    color: #4285F4;
  }
  .order {
    display: flex;
    margin-bottom: 24px;
    &.abstract {
      margin: 4px;
    }
    .order-text {
      width: 60%;
      float: left;
      &.shipping {
        font-size: 12px;
        text-align: right;
        color: rgba(66, 133, 244, 0.75);
      }
      &.amount {
        text-align: right;
        color: #4285F4;
      }
    }
    .order-value {
      width: 40%;
      float: left;
      color: rgba(66, 133, 244, 0.75);
      text-align: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partial/customer/OrderData.vue